import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import * as tags from '../../constants';
import { VolleyRowWrapper, SetWrapper } from './styles';
import TeamLabel from '../TeamLabel';
import Label from '../shared/Label';
import ConfigManager from '../../common/configManager/configManager';
import { getVolleyTeamImagePath } from '../../common/rcs_gaz_mc_core_FE';

const VolleyRow = ({
  matchRow, isMobile, isVolleyCalendarChampionship, dictionary,
}) => {
  const countriesUrl = ConfigManager.getCountriesFlag();
  const volleyTeamsURL = ConfigManager.getVolleyTeams('min');

  const isHomeWinner = (home, away) => {
    home = Number(home);
    away = Number(away);
    if (home > away && home >= 3) {
      return true;
    }
    return false;
  };

  const isAwayWinner = (away, home) => {
    home = Number(home);
    away = Number(away);
    if (away > home && away >= 3) {
      return true;
    }
    return false;
  };

  const isHomeWinnerSet = (home, away, isTb = false) => {
    home = Number(home);
    away = Number(away);
    const limit = isTb ? 15 : 25;
    if (isHomeWinner(home, away) && home >= limit && (home - away) > 1) {
      return true;
    }
    return false;
  };

  const isAwayWinnerSet = (away, home, isTb = false) => {
    home = Number(home);
    away = Number(away);
    const limit = isTb ? 15 : 25;
    if (isAwayWinner(away, home) && away >= limit && (away - home) > 1) {
      return true;
    }
    return false;
  };

  const formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = (`0${dateJs.getHours()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${hours}:${minutes}`;
  };

  const customTeamName = (name) => {
    let customName = name;
    if (name === 'Repubblica Dominicana') {
      customName = 'Rep. Dominicana';
    }
    return customName;
  };

  const imageLogo = (isHome) => {
    let imageUrl = false;
    let newType = true;
    const { competitionId } = window.matchcenterPage;
    if (matchRow.get('teamA')) {
      imageUrl = isHome ? getVolleyTeamImagePath(volleyTeamsURL, matchRow.get('teamA'), competitionId) : getVolleyTeamImagePath(volleyTeamsURL, matchRow.get('teamB'), competitionId);
    } else {
      imageUrl = isHome ? getVolleyTeamImagePath(volleyTeamsURL, { teamCode: matchRow.get('teamACountry') }, competitionId) : getVolleyTeamImagePath(volleyTeamsURL, { teamCode: matchRow.get('teamBCountry') }, competitionId);
    }
    if (imageUrl === false) {
      newType = false;
      if (window.matchcenterPage.competitionId === 35 || window.matchcenterPage.competitionId === 34) {
        imageUrl = isHome ? `${countriesUrl}${matchRow.get('teamACountry')}.jpg` : `${countriesUrl}${matchRow.get('teamBCountry')}.jpg`;
      } else {
        imageUrl = isHome ? `${volleyTeamsURL}${matchRow.get('teamAId')}.png` : `${volleyTeamsURL}${matchRow.get('teamBId')}.png`;
      }
    }
    return (
      <TeamLabel
        image={imageUrl}
        width={newType ? '28px' : 'auto'}
        height={newType ? null : isMobile ? '15px' : '21px'}
        isVolleyCalendarChampionship={isVolleyCalendarChampionship}
      />
    );
  };

  const parseTimeLabel = () => {
    let label = '';
    const statusDictionary = dictionary.competitionTable.timing;
    if (matchRow.get('status')) {
      if (matchRow.get('status') === tags.CANCELED) {
        label = statusDictionary.Cancelled;
      } else if (matchRow.get('status') !== 'Played') {
        label = formatDate(`${matchRow.get('dateUtc')}T${matchRow.get('timeUtc')}Z`);
      } else {
        label = 'Fine';
      }
    }
    return label;
  };

  const isCancelled = () => (matchRow.get('status') && matchRow.get('status') === tags.CANCELED);

  return (
    <VolleyRowWrapper>
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          md={isMobile ? 0.3 : 1}
          sm={isMobile ? 0.3 : 0.8}
          xs={isMobile ? 0.3 : 0.8}
          style={{
            top: isMobile ? '3px' : '7px',
            paddingLeft: '0px',
            paddingRight: '0px',
            alignSelf: 'flex-start',
            marginTop: '8px',
          }}
        />
        <Col
          lg={4.5}
          md={4.5}
          sm={4.5}
          xs={4.5}
          style={{
            paddingLeft: '0px',
            paddingRight: isMobile ? '5px' : '10px',
            marginTop: '0.6em',
            marginBottom: '0.6em',
          }}
        >
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', marginBottom: '0px', alignItems: 'center',
          }}
          >
            {matchRow.get('teamAName') &&
              <Col
                lg={1.5}
                md={1.5}
                sm={2}
                xs={2}
                style={{
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
              >
                {imageLogo(true)}
              </Col>
            }
            <Col
              lg={10.5}
              md={10.5}
              sm={10}
              xs={10}
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              {matchRow && matchRow.get('teamAName') &&
              <Label
                label={customTeamName(matchRow.get('teamAName'))}
                alignSelf="flex-start"
                margin="0px 0px 0px 10px"
                lineHeight={1.1}
                size={0.9}
                isTitleNarrowMedium={matchRow.get('fsA') && matchRow.get('fsB') && isHomeWinner(matchRow.get('fsA'), matchRow.get('fsB'))}
              />
              }
            </Col>
          </Row>
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', marginTop: '0px', alignItems: 'center',
          }}
          >
            {matchRow.get('teamBName') &&
              <Col
                lg={1.5}
                md={1.5}
                sm={2}
                xs={2}
                style={{
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
              >
                {imageLogo(false)}
              </Col>
            }
            <Col
              lg={10.5}
              md={10.5}
              sm={10}
              xs={10}
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              {matchRow && matchRow.get('teamBName') &&
              <Label
                label={customTeamName(matchRow.get('teamBName'))}
                alignSelf="flex-start"
                lineHeight={1.1}
                margin="0px 0px 0px 10px"
                size={0.9}
                isTitleNarrowMedium={matchRow.get('fsA') && matchRow.get('fsB') && isAwayWinner(matchRow.get('fsB'), matchRow.get('fsA'))}
              />
              }
            </Col>
          </Row>
        </Col>
        <Col
          lg={isCancelled ? 2 : 1.5}
          md={isCancelled ? 2 : 1.5}
          sm={isCancelled ? 2 : 1.5}
          xs={isCancelled ? 2 : 1.5}
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: '0px',
            overflow: 'visible',
          }}
        >
          {matchRow.get('timeUtc') && matchRow.get('dateUtc') &&
            <Label
              label={parseTimeLabel()}
              size={isMobile ? 0.8 : 1}
              isTitleNarrowMedium={matchRow.get('status') && matchRow.get('status') === 'Played'}
            />
          }
        </Col>
        <Col
          lg={1.5}
          md={1}
          sm={1}
          xs={1}
          style={{
              paddingLeft: '2px',
              paddingRight: '0px',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'visible',
            }}
        >
          {matchRow.get('fsA') && matchRow.get('fsB') ?
            <React.Fragment>
              <Label
                label={matchRow.get('fsA')}
                margin="0.6em 0"
                isTitleNarrowMedium={matchRow.get('fsA') && matchRow.get('fsB') && isHomeWinner(matchRow.get('fsA'), matchRow.get('fsB'))}
              />
              <Label
                label={matchRow.get('fsB')}
                margin="0.6em 0"
                isTitleNarrowMedium={matchRow.get('fsA') && matchRow.get('fsB') && isAwayWinner(matchRow.get('fsB'), matchRow.get('fsA'))}
              />
            </React.Fragment> :
            <React.Fragment>
              <Label
                label="-"
                margin="0.6em 0"
              />
              <Label
                label="-"
                margin="0.6em 0"
              />
            </React.Fragment>
            }
        </Col>
        <Col
          lg={isCancelled ? 3 : 3.5}
          md={isCancelled ? 3 : 3.5}
          sm={isCancelled ? 3 : 3.5}
          xs={isCancelled ? 3 : 3.5}
          style={{
              paddingLeft: isMobile ? '0px' : '8px',
              paddingRight: isMobile ? '0px' : '10px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              overflow: 'visible',
            }}
        >
          {matchRow.get('p1SA') && matchRow.get('p1SB') &&
            <SetWrapper>
              <Label
                label={matchRow.get('p1SA')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p1SA') && matchRow.get('p1SB') && isHomeWinnerSet(matchRow.get('p1SA'), matchRow.get('p1SB'))}
              />
              <Label
                label={matchRow.get('p1SB')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p1SA') && matchRow.get('p1SB') && isAwayWinnerSet(matchRow.get('p1SB'), matchRow.get('p1SA'))}
              />
            </SetWrapper>
          }
          {matchRow.get('p2SA') && matchRow.get('p2SB') &&
            <SetWrapper>
              <Label
                label={matchRow.get('p2SA')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p2SA') && matchRow.get('p2SB') && isHomeWinnerSet(matchRow.get('p2SA'), matchRow.get('p2SB'))}
              />
              <Label
                label={matchRow.get('p2SB')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p2SA') && matchRow.get('p2SB') && isAwayWinnerSet(matchRow.get('p2SB'), matchRow.get('p2SA'))}
              />
            </SetWrapper>
          }
          {matchRow.get('p3SA') && matchRow.get('p3SB') &&
            <SetWrapper>
              <Label
                label={matchRow.get('p3SA')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p3SA') && matchRow.get('p3SB') && isHomeWinnerSet(matchRow.get('p3SA'), matchRow.get('p3SB'))}
              />
              <Label
                label={matchRow.get('p3SB')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p3SA') && matchRow.get('p3SB') && isAwayWinnerSet(matchRow.get('p3SB'), matchRow.get('p3SA'))}
              />
            </SetWrapper>
          }
          {matchRow.get('p4SA') && matchRow.get('p4SB') &&
            <SetWrapper>
              <Label
                label={matchRow.get('p4SA')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p4SA') && matchRow.get('p4SB') && isHomeWinnerSet(matchRow.get('p4SA'), matchRow.get('p4SB'))}
              />
              <Label
                label={matchRow.get('p4SB')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('p4SA') && matchRow.get('p4SB') && isAwayWinnerSet(matchRow.get('p4SB'), matchRow.get('p4SA'))}
              />
            </SetWrapper>
          }
          {matchRow.get('tbsA') && matchRow.get('tbsB') &&
            <SetWrapper>
              <Label
                label={matchRow.get('tbsA')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('tbsA') && matchRow.get('tbsB') && isHomeWinnerSet(matchRow.get('tbsA'), matchRow.get('tbsB'), true)}
              />
              <Label
                label={matchRow.get('tbsB')}
                margin="0.6em 0.3em"
                size={isMobile ? 0.7 : 0.8}
                isTitleNarrowMedium={matchRow.get('tbsA') && matchRow.get('tbsB') && isAwayWinnerSet(matchRow.get('tbsB'), matchRow.get('tbsA'), true)}
              />
            </SetWrapper>
          }
        </Col>
      </Row>
    </VolleyRowWrapper >
  );
};

VolleyRow.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.any,
  isVolleyCalendarChampionship: PropTypes.bool,
  dictionary: PropTypes.any,
};

export default VolleyRow;



// WEBPACK FOOTER //
// ./src/components/VolleyRow/index.js